import { lazy } from 'react';
import { Route } from 'react-router-dom';

const EhrRedirectComponent = lazy(() => import('../features/ehr/component/EhrRedirectComponent/EhrRedirectComponent'));
const EhrLoginPageComponent = lazy(() => import('../features/ehr/component/EhrLoginPageComponent/EhrLoginPageComponent'));
const EhrAuthorizationContainer = lazy(() => import('../features/ehr/container/EhrAuthorizationContainer/EhrAuthorizationContainer'));

const createEhrRoutes = () => (
  <Route path="/ehr">
    <Route index element={<EhrRedirectComponent />} />
    <Route path="/ehr/login" element={<EhrLoginPageComponent />} />
    <Route path="/ehr/refer" element={<EhrAuthorizationContainer />} />
  </Route>
);

export default createEhrRoutes;
